import Core from "../core";
import { AxiosError, AxiosResponse } from "axios";

async function timeline(emp_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/timeline?emp_id=${emp_id}&locale=${localStorage.getItem("emplang")}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const timelineService = {
  timeline,
};
